import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Regra } from "src/app/regra/regra";
import { AssociacaoService } from "../../../associacao-stepper/associacao.service";
import { ToastService } from "maps-angular-components";

@Component({
  selector: "modal-deletar-associacao",
  templateUrl: "modal-deletar-associacao.component.html",
})
export class ModalDeletarAssociacaoDialogComponent {
  service: AssociacaoService;

  messageService: ToastService;

  dialogRef: MatDialogRef<ModalDeletarAssociacaoDialogComponent>;

  @Output() deletar = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Regra,
    service: AssociacaoService,
    messageService: ToastService,
    dialogRef: MatDialogRef<ModalDeletarAssociacaoDialogComponent>
  ) {
    this.service = service;
    this.messageService = messageService;
    this.dialogRef = dialogRef;
  }

  excluir() {
    this.service.excluirAssociacao(this.data.id).subscribe(
      () => {
        this.messageService.textoLight("Associação excluída com sucesso.");
        this.dialogRef.close();
        this.deletar.emit({ associacao: this.data });
      },
      err => {
        console.log(err);
        this.messageService.erro(err.error.message);
      }
    );
  }
}
